/* eslint-disable @nrwl/nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectorRef,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  viewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AbcCore, CollectionHelper, CompareHelper, ConvertHelper } from '@barthauer/abc/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { AbcTextBoxComponent } from '@barthauer/abc/ui-components';
import { firstValueFrom, from, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, takeUntil, timeout } from 'rxjs/operators';
import { AuthenticationInterceptor } from '../interceptor/interceptor';
import { AuthenticationLevelMode, AuthenticationProviderType, LoginInfo } from '../models/login-info.model';
import { InputState, LoginViewMode, LoginViewState, SecondFactorViewMode } from '../models/login-settings.model';
import { UserService } from '../services/user.service';
import { WebApiInfoService } from '../services/webapi-info.service';
import { TwoStepAuthComponent } from '../two-step-auth/two-step-auth.component';
import { WebApiInfo } from './../models/webapi-info.model';

@Component({
  selector: 'abc-authentication-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  public userNameInput = viewChild<AbcTextBoxComponent>('userNameInput');
  public passwordInput = viewChild<AbcTextBoxComponent>('passwordInput');
  public twoStepAuthComponent = viewChild(TwoStepAuthComponent);

  @Input() showResetPassword = false;
  @Input() showRegistration = false;
  @Input() useCustomLoader = false;
  @Input() errorClass: string;
  @Input() logoUrl: string;
  @Input() specialLogin: boolean;
  @Input() loaderValue = 0;
  @Input() twoFaIssuer: string;

  @Output() onNeedsPasswordChange: EventEmitter<void> = new EventEmitter();
  @Output() onForgotPasswordClicked: EventEmitter<void> = new EventEmitter();

  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;
  public username: AbstractControl;
  public get hasUserName(): boolean {
    return this.username.value?.length > 0;
  }
  public password: AbstractControl;
  public get hasPassword(): boolean {
    return this.password.value?.length > 0;
  }
  public showLoader = false;
  public confirmationcodeFilled = false;
  public loginLockoutWarning = false;
  public loginLockout = false;
  public lockoutRetries: number;
  public lockoutSeconds: number;
  public lockoutTimer: number;
  public lockoutEnd: Date;
  public get lockoutEndString(): string {
    return this.lockoutEnd?.toLocaleTimeString(ResourceManagerService.getCurrentLanguage());
  }
  public placeholders: string[] = ['0', '0', '0', '0', '0', '0'];
  public inputMode!: string;
  public inputType!: string;
  public twoFactorCode: string;
  public Form: UntypedFormGroup;
  public errorExist = false;
  public ApplicationTitle: string;
  public LoginIntroHtml: string;
  public ForwardToRoutePath: string;
  public ForceReloadOnApply: string;
  public ErrorMessage = signal<string>('');
  public isChangingWebApiSupported: boolean;
  public isAllowBaseURLChange: boolean;
  public Errors = false;
  public pw_vis: boolean;
  public isPasswordChanged = false;
  public currentWebApiInfo$: Observable<WebApiInfo>;
  private destroy$ = new Subject<void>(); // used to cancel Observable chains when component is destroyed
  public rtlEnabled: boolean;
  public secret = signal<string>('');
  public issuer: string;
  public baseUrl: string;
  public viewState = new LoginViewState();
  public secondFactorMode: AuthenticationLevelMode;
  public sessions: {
    user_name: string;
    client_id_toreplace: string;
    max_licenses_reached: boolean;
    max_sessions_reached: boolean;
  }[] = [];
  public clientIdToReplace: string;
  public templateIcons = signal<Map<string, string>>(undefined);
  // these attributes are used for showing clear buttons on autofill
  public passwordAutofilled = signal<boolean>(false);
  public userNameAutoFilled = signal<boolean>(false);
  //

  private codeLength!: number;
  private inputs: HTMLInputElement[] = [];
  private _codeLength = 6;
  private initialFocusField?: number;
  private isFocusingOnLastByClickIfFilled = true;
  private isCharsCode = true;
  private isNonDigitsCode = false;
  private inputsStates: InputState[] = [];
  private isPrevFocusableAfterClearing = true;
  private state = {
    isFocusingAfterAppearingCompleted: false,
    isInitialFocusFieldEnabled: false,
  };
  private inputsListSubscription!: Subscription;
  private code?: string | number;
  private loginInfo: LoginInfo;

  constructor(
    private fb: UntypedFormBuilder,
    private webApiInfoService: WebApiInfoService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private configService: AbcConfigService,
    private abcCore: AbcCore,
    private resourceService: ResourceManagerService
  ) {
    this.resAsync = this.resourceService.getResourceSet('abc-core-authentication');
    this.rtlEnabled = this.resourceService.isRightToLeftEnabled;

    this.createForm();

    this.isChangingWebApiSupported = this.webApiInfoService.isChangingWebApiSupported(this.router);
    this.isAllowBaseURLChange = <boolean>this.configService.configuration?.WebApi?.AllowBaseURLChange;

    this.route.data.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data) => {
        this.ApplicationTitle = data.ApplicationTitle;
        this.ForwardToRoutePath = data.ForwardTo;
        this.ForceReloadOnApply = data.ForceReloadOnApply;
        if (data.LoginIntroHtml) {
          this.LoginIntroHtml = data.LoginIntroHtml;
        }
      },
      error: (err) => this.abcCore.error.publish(err),
    });

    if (document.getElementsByClassName('percentage')[0]) {
      document.getElementsByClassName('percentage')[0]['style'].display = 'none';
      document.getElementsByClassName('circle')[0]['style'].display = 'none';
    }

    effect(() => {
      if (this.twoStepAuthComponent()) {
        const inputList = this.twoStepAuthComponent().inputsList();
        this.onInputsListChanges(inputList);
        this.changeDetectorRef.detectChanges();
      }
    });

    effect(() => {
      if (this.userNameInput()) {
        this.detectAutofill(this.userNameInput().instance.element().querySelector('input')).then((isAutofilled) => {
          if (isAutofilled) {
            this.userNameInput().labelMode = 'static';
            this.userNameInput().instance.element().classList.remove('dx-texteditor-empty');
            this.userNameAutoFilled.set(true);
          }
        });
      }

      if (this.passwordInput()) {
        this.detectAutofill(this.passwordInput().instance.element().querySelector('input')).then((isAutofilled) => {
          if (isAutofilled) {
            this.passwordInput().labelMode = 'static';
            this.passwordInput().instance.element().classList.remove('dx-texteditor-empty');
            this.passwordAutofilled.set(true);
          }
        });
      }
    });
  }
  async ngOnInit() {
    this.showLoader = false;
    this.confirmationcodeFilled = false;
    this.twoFactorCode = '';
    this.viewState.changeSecondFactor(SecondFactorViewMode.None);
    this.viewState.change(LoginViewMode.Login);

    this.state.isInitialFocusFieldEnabled = !this.isEmpty(this.initialFocusField);

    this.onCodeLengthChanges();

    this.res = await this.resAsync;

    this.templateIcons.set(
      new Map([
        ['clearIcon', await this.res.svgContent('InputClear-Image')],
        ['passwordHideIcon', await this.res.svgContent('PasswordHide-Image')],
        ['passwordShowIcon', await this.res.svgContent('PasswordShow-Image')],
      ])
    );

    this.currentWebApiInfo$ = this.webApiInfoService
      .getCurrentWebApiInfo()
      .pipe(
        catchError(() => of(WebApiInfo.CreateInvalidWebApiBaseURLInfo(this.configService.configuration.WebApi.BaseURL)))
      );

    const loginIntroTextDiv = document.getElementById('LoginIntroText');
    if (loginIntroTextDiv && this.LoginIntroHtml) {
      loginIntroTextDiv.innerHTML = this.LoginIntroHtml;
    }

    const loginRedirectMode = sessionStorage.getItem(AuthenticationInterceptor.LoginRedirectModeKey);
    if (loginRedirectMode) {
      sessionStorage.removeItem(AuthenticationInterceptor.LoginRedirectModeKey);
      this.Errors = true;
      this.ErrorMessage.set(loginRedirectMode);
    }
  }

  private detectAutofill(element: HTMLElement): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      setTimeout(() => {
        const isAutofilled =
          window.getComputedStyle(element, null).getPropertyValue('appearance') === 'menulist-button';
        resolve(isAutofilled);
      }, 200);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null); // trigger the unsubscribe
    this.destroy$.complete(); // finalize & clean up the subject stream

    if (this.inputsListSubscription) {
      this.inputsListSubscription.unsubscribe();
    }
  }

  public clearLastValidation(): void {
    this.errorExist = false;
    this.Errors = false;
    this.ErrorMessage.set(null);

    this.passwordAutofilled.set(false);
    this.userNameAutoFilled.set(false);
  }

  public onSubmit(): void {
    if (!this.hasUserName && !this.hasPassword) {
      this.userNameInput().instance.element().style.border = `1px solid #f53c56`;
      this.passwordInput().instance.element().style.border = `1px solid #f53c56`;

      this.ErrorMessage.set('missing_credentials');
      return;
    } else if (!this.hasUserName) {
      this.userNameInput().instance.element().style.border = `1px solid #f53c56`;

      this.ErrorMessage.set('missing_username');
      return;
    } else if (!this.hasPassword) {
      this.passwordInput().instance.element().style.border = `1px solid #f53c56`;
      this.ErrorMessage.set('missing_password');
      return;
    }

    clearInterval(this.lockoutTimer);
    this.clearLastValidation();
    this.errorExist = true;

    try {
      localStorage.removeItem('mfaInProgress');
    } catch {}

    if (this.Form.valid) {
      this.showLoader = true;
      this.loaderValue = 10;

      this.loginCore();
    }
  }

  public onForgotPassword(): void {
    this.onForgotPasswordClicked.emit();
  }

  public onSessionSelected(selectedSessionId: string) {
    this.loginCore(selectedSessionId);
  }

  public async onSubmitButtonKeydown(e: any): Promise<void> {
    if (this.isEnterKey(e)) {
      this.twoStepAuthComponent().submitButton()?.nativeElement.click();
    }
  }

  public setOptionalSecondFactor = async () => {
    await this.requireSecondFactor(false);
  };

  public confirmSecondFactor = async () => {
    const routePath: string = this.ForwardToRoutePath || '/';

    switch (this.secondFactorMode) {
      case AuthenticationLevelMode.Optional:
      case AuthenticationLevelMode.Invalid:
        await this.rerouteLogin(routePath);
        break;
      case AuthenticationLevelMode.RequiredToConfirm:
        if (this.confirmationcodeFilled) {
          try {
            await this.userService.updateIdentity(AuthenticationProviderType.AppTotp, '', this.twoFactorCode);
            await this.userService
              .loginUser(
                this.username.value,
                this.password.value,
                this.twoFactorCode,
                this.getOtpIdentifier(AuthenticationProviderType.AppTotp)
              )
              .toPromise();

            try {
              localStorage.removeItem('mfaInProgress');
            } catch {}

            this.setupSecondFactor(SecondFactorViewMode.None, AuthenticationLevelMode.Confirmed);
            await this.rerouteLogin(routePath, true);
          } catch (error) {
            this.setupSecondFactor(SecondFactorViewMode.SetupInvalidCode);
            return;
          }
        }
        break;
      case AuthenticationLevelMode.Confirmed:
      case AuthenticationLevelMode.ConfirmedDeprecated:
        if (this.confirmationcodeFilled) {
          this.userService
            .loginUser(
              this.username.value,
              this.password.value,
              this.twoFactorCode,
              this.getOtpIdentifier(AuthenticationProviderType.AppTotp)
            )
            .subscribe(
              async () => {
                try {
                  localStorage.removeItem('mfaInProgress');
                } catch {}

                if (this.secondFactorMode == AuthenticationLevelMode.Confirmed) {
                  await this.rerouteLogin(routePath);
                } else {
                  await this.requireSecondFactor(true);
                }
              },
              (error) => {
                this.setupSecondFactor(SecondFactorViewMode.InvalidCode);
              }
            );
        }
        break;
    }
  };

  public cancelSecondFactor = async (): Promise<void> => {
    await this.userService.logoutCurrentUser(false);

    try {
      localStorage.removeItem('mfaInProgress');
    } catch {}

    const isCordova = !!(window as any)?.cordova;
    if (isCordova) {
      this.viewState.changeSecondFactor(SecondFactorViewMode.None);
      this.secondFactorMode = AuthenticationLevelMode.None;
      this.twoFactorCode = '';
      this.confirmationcodeFilled = false;

      this.viewState.change(LoginViewMode.Login);
      this.showLoader = false;
      this.back();
    } else {
      window.location.reload();
    }
  };

  public async rerouteLogin(routePath: string, refreshLoginInfo?: boolean): Promise<void> {
    if (refreshLoginInfo) {
      this.loginInfo = undefined;
    }
    const loginInfo = await this.ensureCurrentLoginInfo();

    if (loginInfo.needsPasswordChange) {
      this.loginInfo = undefined;
      this.onNeedsPasswordChange.emit();
      this.viewState.change(LoginViewMode.ChangePassword);
    } else {
      if (this.ForceReloadOnApply) {
        AuthenticationInterceptor.reload(routePath);
      } else {
        await this.userService.getAccountLanguage();
        this.router.navigate([routePath]);
      }
    }
  }

  public back(): void {
    this.username.setValue('');
    this.password.setValue('');
    this.userNameAutoFilled.set(false);
    this.passwordAutofilled.set(false);
    this.viewState.change(LoginViewMode.Login);
    this.ErrorMessage.set(null);

    const u = this.userNameInput();
    const p = this.passwordInput();

    if (u) {
      u.labelMode = 'floating';
    }
    if (p) {
      p.labelMode = 'floating';
    }
  }

  public editWebAPI(): void {
    from(this.webApiInfoService.navigateToWebApiEditorPage(this.router, this.route, '/'))
      .pipe(takeUntil(this.destroy$))
      .subscribe({ error: (err) => this.abcCore.error.publish(err) });
  }

  public onInputClick(): void {
    this.userNameInput().instance.element().style.border = `1px solid var(--PrimaryMainColor)`;
    this.passwordInput().instance.element().style.border = `1px solid var(--PrimaryMainColor)`;
    this.userNameInput().labelMode = 'floating';
    this.passwordInput().labelMode = 'floating';
  }

  public onClearClick = (): void => {
    this.Errors = false;
    this.changeDetectorRef.detectChanges();
  };

  public clearUserName = (): void => {
    this.username.setValue('');
    this.userNameInput().labelMode = 'floating';
    this.userNameInput().instance.focus();
    this.onClearClick();
  };

  public clearPassword = (): void => {
    this.password.setValue('');
    this.passwordInput().labelMode = 'floating';
    this.passwordInput().instance.focus();
    this.onClearClick();
  };

  public togglePasswordVisibility = (): void => {
    this.pw_vis = !this.pw_vis;
    this.changeDetectorRef.detectChanges();
  };

  public onPasswordBeforeInput(): void {
    if (!this.isPasswordChanged) {
      this.isPasswordChanged = true;
      this.password.setValue('');
    }
  }

  public onClick = (e: any): void => {
    // handle click events only if the the prop is enabled
    if (!this.isFocusingOnLastByClickIfFilled) {
      return;
    }

    const target = e.target;
    const last = this.inputs[this._codeLength - 1];
    // already focused
    if (target === last) {
      return;
    }

    // check filling
    const isFilled = this.getCurrentFilledCode().length >= this._codeLength;
    if (!isFilled) {
      return;
    }

    // focusing on the last input if is filled
    setTimeout(() => last.focus());
  };

  public onPaste = (e: ClipboardEvent, i: number): void => {
    e.preventDefault();
    e.stopPropagation();

    const data = e.clipboardData ? e.clipboardData.getData('text').trim() : undefined;

    if (this.isEmpty(data)) {
      return;
    }

    // Convert paste text into iterable
    // tslint:disable-next-line:no-non-null-assertion
    const values = data!.split('');
    let valIndex = 0;

    for (let j = i; j < this.inputs.length; j++) {
      // The values end is reached. Loop exit
      if (valIndex === values.length) {
        break;
      }

      const input = this.inputs[j];
      const val = values[valIndex];

      // Cancel the loop when a value cannot be used
      if (!this.canInputValue(val)) {
        this.setInputValue(input, null);
        this.setStateForInput(input, InputState.reset);
        return;
      }

      this.setInputValue(input, val.toString());
      valIndex++;
    }

    this.inputs[i].blur();
    this.emitChanges();
  };

  public onInput = (e: any, i: number): void => {
    const target = e.target as HTMLInputElement;
    const value = target.value;

    if (this.isEmpty(value)) {
      return;
    }

    // only digits are allowed if isCharsCode flag is absent/false
    if (!this.canInputValue(value)) {
      e.preventDefault();
      e.stopPropagation();
      this.setInputValue(target, null);
      this.setStateForInput(target, InputState.reset);
      return;
    }

    this.setInputValue(target, value);

    this.emitChanges();

    setTimeout(() => {
      const container = target.closest('.input-qrCode');
      if (!container) {
        return;
      }

      const inputs = Array.from(container.querySelectorAll('input')) as HTMLInputElement[];

      const currentIndex = inputs.indexOf(target);
      if (currentIndex === -1) {
        return;
      }

      const nextInput = inputs[currentIndex + 1];
      if (!nextInput) {
        return;
      }

      nextInput.focus();
    }, 0);
  };

  public onKeydown = (e: any, i: number): void => {
    const target = e.target as HTMLInputElement;
    const key = e.key as string;

    if (key !== 'Backspace' && key !== 'Delete') {
      return;
    }

    e.preventDefault();

    const hadValue = !this.isEmpty(target.value);

    if (key === 'Delete') {
      if (hadValue) {
        this.setInputValue(target, null);
        this.emitChanges();
      }
      return;
    }

    if (hadValue) {
      this.setInputValue(target, null);
      this.emitChanges();

      setTimeout(() => {
        const container = target.closest('.input-qrCode');
        if (!container) {
          return;
        }

        const inputs = Array.from(container.querySelectorAll('input')) as HTMLInputElement[];

        const currentIndex = inputs.indexOf(target);
        if (currentIndex === -1 || currentIndex === 0) {
          return;
        }

        const prevInput = inputs[currentIndex - 1];
        if (!prevInput) {
          return;
        }

        prevInput.focus();
      }, 0);

      return;
    }

    setTimeout(() => {
      const container = target.closest('.input-qrCode');
      if (!container) {
        return;
      }

      const inputs = Array.from(container.querySelectorAll('input')) as HTMLInputElement[];

      const currentIndex = inputs.indexOf(target);
      if (currentIndex === -1 || currentIndex === 0) {
        return;
      }

      const prevInput = inputs[currentIndex - 1];
      if (!prevInput) {
        return;
      }

      if (!this.isEmpty(prevInput.value)) {
        this.setInputValue(prevInput, null);
        this.emitChanges();
      }

      prevInput.focus();
    }, 0);
  };

  private getOtpIdentifier(type: AuthenticationProviderType): string {
    switch (type) {
      case AuthenticationProviderType.AppTotp:
        return 'app_totp';
      case AuthenticationProviderType.Email:
        return 'email_otp';
      case AuthenticationProviderType.Phone:
        return 'phone_otp';
    }
  }

  private createForm(): void {
    this.Form = this.fb.group({
      username: [''],
      password: [''],
    });
    this.username = this.Form.get('username');
    this.password = this.Form.get('password');
  }

  private async requireSecondFactor(isDeprecated: boolean): Promise<void> {
    if (!this.secret().length || isDeprecated) {
      this.issuer = encodeURIComponent(
        this.twoFaIssuer ?? this.res.get('SecondFactor-IssuerFormat', await this.userService.getSystemName())
      );
      this.secret.set(await this.userService.updateIdentity(AuthenticationProviderType.AppTotp, ''));
    }
    this.setupSecondFactor(
      isDeprecated ? SecondFactorViewMode.SetupDeprecated : SecondFactorViewMode.Setup,
      AuthenticationLevelMode.RequiredToConfirm
    );
  }

  private setupSecondFactor(viewMode: SecondFactorViewMode, mode?: AuthenticationLevelMode) {
    for (let i = 0; i < this.inputs?.length; i++) {
      this.inputs[i].value = '';
    }
    this.viewState.changeSecondFactor(viewMode);
    if (mode) {
      this.secondFactorMode = mode;
    }

    try {
      localStorage.setItem('mfaInProgress', '1');
    } catch {}

    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      if (this.inputs?.length) {
        this.inputs[0].focus();
      }
    }, 10);
  }

  private loginCore(clientIdToReplace?: string): void {
    this.loaderValue = 10;

    this.loginInfo = undefined;

    this.userService
      .loginUser(this.username.value, this.password.value, undefined, undefined, clientIdToReplace)
      .pipe(takeUntil(this.destroy$)) // Avoid login and routing if page was left before server response arrived
      .subscribe({
        next: async () => {
          let routePath: string;
          if (this.ForwardToRoutePath) {
            routePath = this.ForwardToRoutePath;
          } else {
            routePath = '/';
          }

          this.loaderValue = 50;
          this.baseUrl = this.configService.getWebApiBaseURL();

          let loginInfo: LoginInfo;

          try {
            loginInfo = await this.ensureCurrentLoginInfo();
          } catch (error) {
            this.showLoader = false;

            this.Errors = true;
            this.ErrorMessage.set('refresh_token');

            try {
              await this.userService.logoutCurrentUser(false);
            } catch {}

            this.viewState.changeSecondFactor(SecondFactorViewMode.None);
            this.viewState.change(LoginViewMode.Login);
            this.changeDetectorRef.detectChanges();
            return;
          }

          switch (loginInfo.secondFactorMode) {
            case AuthenticationLevelMode.Confirmed:
            case AuthenticationLevelMode.ConfirmedDeprecated:
              this.setupSecondFactor(SecondFactorViewMode.Input, loginInfo.secondFactorMode);
              break;
            case AuthenticationLevelMode.Invalid:
              this.viewState.changeSecondFactor(SecondFactorViewMode.InvalidConfig);
              break;
            case AuthenticationLevelMode.None:
              this.viewState.changeSecondFactor(SecondFactorViewMode.None);
              await this.rerouteLogin(routePath);
              break;
            case AuthenticationLevelMode.Optional:
              this.setupSecondFactor(SecondFactorViewMode.ShouldSetup, AuthenticationLevelMode.Optional);
              break;
            case AuthenticationLevelMode.RequiredToConfirm:
              await this.requireSecondFactor(false);
              break;
            default:
              await this.rerouteLogin(routePath);
              break;
          }
        },
        error: (err) => {
          if (err.error.error === 'invalid_config') {
            this.viewState.changeSecondFactor(SecondFactorViewMode.InvalidConfig);
          } else if (err.error.error === 'invalid_sessions') {
            const json = JSON.parse(err.error?.error_description);

            this.showLoader = false;
            this.ErrorMessage.set('invalid_session');
            this.viewState.change(LoginViewMode.TakeoverSession);

            console.warn(json);
            const sessions = json?.conflicting_sessions;
            this.sessions = sessions ?? [];

            const oldestSession = this.sessions[0];
            if (this.sessions.length == 0) {
              this.sessions.push({
                user_name: this.res.get('Login-AnySession'),
                client_id_toreplace: 'unknown',
                max_licenses_reached: true,
                max_sessions_reached: false,
              });
            }
            const userNames = new Set<string>();
            if (oldestSession) {
              userNames.add(oldestSession.user_name);
            }
            this.sessions = this.sessions
              .filter((session) => {
                if (userNames.has(session.user_name)) {
                  return false;
                }
                userNames.add(session.user_name);
                return true;
              })
              .sort((s1, s2) =>
                CompareHelper.compare(s1.user_name.toLocaleUpperCase(), s2.user_name.toLocaleUpperCase())
              );
            if (oldestSession) {
              CollectionHelper.insertAt(this.sessions, 0, oldestSession);
              oldestSession.user_name = this.res.get('Login-OldestSession-Format', oldestSession.user_name);
            }
          } else {
            this.showLoader = false;
            this.ErrorMessage.set(err.message);

            setTimeout(() => {
              this.userNameInput().instance.element().style.border = `1px solid #f53c56`;
              this.passwordInput().instance.element().style.border = `1px solid #f53c56`;
            });

            if (err.error?.error_description) {
              this.Errors = true;
              const lockoutEnd = err.headers?.get('Lockout-End');
              const lockoutRetries = err.headers?.get('Lockout-Counter');
              if (lockoutEnd) {
                console.warn('Account is locked until: ' + ConvertHelper.fromString(Date, lockoutEnd));
                this.lockoutEnd = <Date>ConvertHelper.fromString(Date, lockoutEnd);
                this.loginLockoutWarning = false;
                this.loginLockout = true;
                this.lockoutSeconds = parseInt(err.headers.get('Lockout-Seconds'));
                this.lockoutTimer = setInterval(() => {
                  this.lockoutSeconds--;
                }, 1000) as unknown as number;
                setTimeout(
                  () => {
                    clearInterval(this.lockoutTimer);
                    this.loginLockout = false;
                    this.loginLockoutWarning = false;
                  },
                  parseInt(err.headers.get('Lockout-Seconds')) * 1000
                );
              } else if (lockoutRetries) {
                console.warn('Account will be locked after: ' + lockoutRetries);
                this.lockoutRetries = lockoutRetries;
                this.loginLockout = false;
                this.loginLockoutWarning = true;
              }
              this.ErrorMessage.set(err.error.error_description);
            }
          }

          this.changeDetectorRef.detectChanges();
        },
        complete: () => {
          this.loaderValue = 100;
        },
      });
  }

  private getCurrentFilledCode(): string {
    let code = '';

    for (const input of this.inputs) {
      if (!this.isEmpty(input.value)) {
        code += input.value;
      }
    }

    return code;
  }

  private isEmpty(value: any): boolean {
    return value === null || value === undefined || !value.toString().length;
  }

  private canInputValue(value: any): boolean {
    if (this.isEmpty(value)) {
      return false;
    }

    const isDigitsValue = /^[0-9]+$/.test(value.toString());
    return isDigitsValue || this.isCharsCode || this.isNonDigitsCode;
  }

  private setInputValue(input: HTMLInputElement, value: any): void {
    const isEmpty = this.isEmpty(value);

    if (isEmpty) {
      input.value = '';
    } else {
      input.value = value;
    }

    this.confirmationcodeFilled = this.placeholders.length === this.getCurrentFilledCode().length;
  }

  private setStateForInput(input: HTMLInputElement, state: InputState): void {
    const index = this.inputs.indexOf(input);
    if (index < 0) {
      return;
    }

    this.inputsStates[index] = state;
  }

  private emitChanges(): void {
    setTimeout(() => this.emitCode(), 50);
  }

  private emitCode(): void {
    const code = this.getCurrentFilledCode();

    if (code.length >= this._codeLength) {
      this.twoFactorCode = code;
    }
  }

  private isDeleteKey(e: any): boolean {
    return (e.key && e.key.toLowerCase() === 'delete') || (e.keyCode && e.keyCode === 46);
  }

  private isEnterKey(e: any): boolean {
    return (e.key && e.key.toLowerCase() === 'enter') || (e.keyCode && e.keyCode === 13);
  }

  private isBackspaceKey(e: any): Promise<boolean> {
    const isBackspace = (e.key && e.key.toLowerCase() === 'backspace') || (e.keyCode && e.keyCode === 8);
    if (isBackspace) {
      return Promise.resolve(true);
    }

    // process only key with placeholder keycode on android devices
    if (!e.keyCode || e.keyCode !== 229) {
      return Promise.resolve(false);
    }

    return new Promise<boolean>((resolve) => {
      setTimeout(() => {
        const input = e.target;
        const isReset = this.getStateForInput(input) === InputState.reset;
        if (isReset) {
          this.setStateForInput(input, InputState.ready);
        }
        // if backspace key pressed the caret will have position 0 (for single value field)
        resolve(input.selectionStart === 0 && !isReset);
      });
    });
  }

  private getStateForInput(input: HTMLInputElement): InputState | undefined {
    const index = this.inputs.indexOf(input);
    return this.inputsStates[index];
  }

  private onInputsListChanges(list: readonly ElementRef[]): void {
    if (list.length > this.inputs.length) {
      const inputsToAdd = list.filter((item, index) => index > this.inputs.length - 1);
      this.inputs.splice(this.inputs.length, 0, ...inputsToAdd.map((item) => item.nativeElement));
      const states = Array(inputsToAdd.length).fill(InputState.ready);
      this.inputsStates.splice(this.inputsStates.length, 0, ...states);
    } else if (list.length < this.inputs.length) {
      this.inputs.splice(list.length);
      this.inputsStates.splice(list.length);
    }

    // filling the inputs after changing of their count
    this.onInputCodeChanges();
  }

  private onInputCodeChanges(): void {
    if (!this.inputs.length) {
      return;
    }

    if (this.isEmpty(this.code)) {
      this.inputs.forEach((input: HTMLInputElement) => {
        this.setInputValue(input, null);
      });
      return;
    }

    // tslint:disable-next-line:no-non-null-assertion
    const chars = this.code!.toString().trim().split('');
    // checking if all the values are correct
    let isAllCharsAreAllowed = true;
    for (const char of chars) {
      if (!this.canInputValue(char)) {
        isAllCharsAreAllowed = false;
        break;
      }
    }

    this.inputs.forEach((input: HTMLInputElement, index: number) => {
      const value = isAllCharsAreAllowed ? chars[index] : null;
      this.setInputValue(input, value);
    });
  }

  private onCodeLengthChanges(): void {
    if (!this.codeLength) {
      return;
    }

    this._codeLength = this.codeLength;
    if (this._codeLength > this.placeholders.length) {
      const numbers = Array(this._codeLength - this.placeholders.length).fill(1);
      this.placeholders.splice(this.placeholders.length - 1, 0, ...numbers);
    } else if (this._codeLength < this.placeholders.length) {
      this.placeholders.splice(this._codeLength);
    }
  }

  private async ensureCurrentLoginInfo(): Promise<LoginInfo> {
    if (!this.loginInfo) {
      try {
        this.loginInfo = await firstValueFrom(
          this.userService.getCurrentLoginInfo(this.viewState.showChangePassword).pipe(timeout(15000))
        );
      } catch (error) {
        throw error;
      }
    }

    this.changeDetectorRef.detectChanges();
    return this.loginInfo;
  }
}
